import {
  GET_USER_MEAL_PLAN,
  GET_USER_MEAL_PLAN_SUCCESS,
  GET_USER_MEAL_PLAN_ERROR,
  SAVE_USER_MEAL_PLAN,
  SAVE_USER_MEAL_PLAN_SUCCESS,
  SAVE_USER_MEAL_PLAN_ERROR,
  DELETE_USER_MEAL_PLAN,
  DELETE_USER_MEAL_PLAN_SUCCESS,
  DELETE_USER_MEAL_PLAN_ERROR,
  SET_USER_MEAL_PLAN,
} from './constants';

const initialState = {
  userMealPlan: {},
  userMealPlanLoading: false,
  userMealPlanError: null,
};

function mealPlan(state = initialState, action) {
  const { type, payload } = action;
  switch (type) {
    case GET_USER_MEAL_PLAN:
    case SAVE_USER_MEAL_PLAN:
      return {
        ...state,
        userMealPlanLoading: true,
        userMealPlanError: null,
      };
    case GET_USER_MEAL_PLAN_SUCCESS:
    case SAVE_USER_MEAL_PLAN_SUCCESS:
    case SET_USER_MEAL_PLAN:
      return {
        ...state,
        userMealPlan: payload,
        userMealPlanLoading: false,
      };
    case GET_USER_MEAL_PLAN_ERROR:
    case SAVE_USER_MEAL_PLAN_ERROR:
      return {
        ...state,
        userMealPlanLoading: false,
        userMealPlanError: payload,
      };
    case DELETE_USER_MEAL_PLAN:
      return {
        ...state,
        isWelcomeModalVisible: action.payload,
      };
    case DELETE_USER_MEAL_PLAN_SUCCESS:
      return {
        ...state,
        isGenerateMealPlanModalVisible: action.payload,
      };
    case DELETE_USER_MEAL_PLAN_ERROR:
      return {
        ...state,
        advancedModeMacros: action.payload,
      };
    default:
      return state;
  }
}

export default mealPlan;
